var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useRef } from 'react';
import { KEYBOARD } from 'modules/constants';
import { Item } from './Item';
import { Container, Dot } from './styled';
function PageIndicator(props) {
    const { stretch = false, panelId, current = 0, values = [], onSelect } = props, restProps = __rest(props, ["stretch", "panelId", "current", "values", "onSelect"]);
    const containerRef = useRef(null);
    const handleKeyDown = (event) => {
        var _a;
        const rightKey = event.key === KEYBOARD.ARROW_RIGHT;
        const leftKey = event.key === KEYBOARD.ARROW_LEFT;
        if (rightKey || leftKey) {
            const nextIndex = rightKey ? current + 1 : current - 1;
            if (nextIndex >= 0 && nextIndex <= values.length - 1) {
                if (onSelect) {
                    onSelect(nextIndex, event);
                }
                const nextElement = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.children[nextIndex];
                if (nextElement instanceof HTMLElement) {
                    nextElement.focus();
                }
            }
        }
    };
    return (<Container {...restProps} ref={containerRef} role="tablist" $stretch={stretch}>
      {values.map((label, index) => {
            const selected = current === index;
            return (<Item 
            // eslint-disable-next-line react/no-array-index-key
            key={index} index={index} tabIndex={selected ? 0 : -1} aria-controls={panelId} aria-label={label} aria-selected={selected} onKeyDown={handleKeyDown} onSelect={onSelect}>
            <Dot $selected={selected}/>
          </Item>);
        })}
    </Container>);
}
export default PageIndicator;
